const role = [
  {
    title: 'Linknau Internal',
    type: 'internal',
    roles: ['SuperAdmin', 'CustomAdmin']
  },
  {
    title: 'Partner Logistic with no System',
    type: 'partner-0',
    roles: ['Admin', 'PertashopOwner', 'CustomAdmin']
  },
  {
    title: 'Partner Logistic with System Ready',
    type: 'partner-1',
    roles: ['Admin', 'CustomAdmin']
  }
]
export default role
